import * as z from "zod/v4";

export const bulkAddTopicsToPrompts = {
  name: "bulkAddTopicsToPrompts" as const,
  input: z.object({
    promptIds: z.array(z.bigint()),
    topicIds: z.array(z.bigint()),
  }),
  output: z.object({}),
};
